import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from '../actions/auth';
import Footer from './Footer';

import SlideIn from "../components/animations/SlideIn";
import FadeIn from "../components/animations/FadeIn";

const Login = ({ login, isAuthenticated }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '' 
    });

    const { email, password } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = e => {
        e.preventDefault();
        login(email, password);
    };

   
    if (isAuthenticated) {
        return <Redirect to='/' />
    }
    return (
        <>
        <br/><br/>
        <div className="login-bg-image image-background">
            <FadeIn>
                <h1 style={{textAlign: 'center', color: 'white', paddingTop: '90px', fontFamily: 'Lobster'}}>Start your journey with us!</h1>
            </FadeIn>
            <SlideIn>    
                <div className="d-flex justify-content-center h-100">
                <div className="card box-shadow" style={{height: '360px',marginTop: '20px',marginBottom: '150px',width: '400px'}}>
                    <div className="card-header">
                        <h3>Sign In</h3>
                        Sign into your Account
                    </div>
                    <div className="card-body">
                    <form onSubmit={e => onSubmit(e)}>
                        <div className="input-group form-group mt-2">
                        <span className="input-group-text blue-theme-color" style={{width:'55px'}}><i className="fa fa-user ml-2"></i></span>
                            <input className='form-control'
                                type='email'
                                placeholder='Email'
                                name='email'
                                value={email}
                                onChange={e => onChange(e)}
                                required 
                            />
                        </div>
                        <div className="input-group form-group">
                            <span className="input-group-text blue-theme-color" style={{width:'55px'}}><i className="fa fa-key ml-2"></i></span>
                            <input  className='form-control'
                                type='password'
                                placeholder='Password'
                                name='password'
                                value={password}
                                onChange={e => onChange(e)}
                                minLength='6'
                                required/>
                        </div>
                        <div className="remember">
                            Remember Me <input type="checkbox"  className='ms-2'/>
                        </div>
                        <div className="form-group">
                            <button className='btn btn-primary float-right blue-theme-color' type='submit' style={{width: '100px'}}>Login</button>
                        </div>
                    </form>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex justify-content-center links">
                            Don't have an account?<Link to='/signup'>Sign Up</Link>
                        </div>
                        <div className="d-flex justify-content-center">
                            <Link to='/reset-password'>Forgot your password?</Link>
                        </div>
                    </div>
                </div>
                </div>
            </SlideIn>
		</div>
        <Footer />
        </>
    );
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { login })(Login);
